import seoApi from '@/backend/services/seo/seoBoard.js'

export default {
  state: {
    languageList: []
  },
  mutations: {
    SET_LANGUAGE(state, data) {
      state.languageList = _.cloneDeep(data)
    }
  },
  actions: {
    getLanguageList({ commit, state }) {
      return new Promise((resolve, reject) => {
        seoApi
          .languageList()
          .then(res => {
            commit('SET_LANGUAGE', res.data)
            resolve(state.languageList)
          })
          .catch(e => reject(e))
      })
    }
  }
}
